module.exports = "/_next/static/images/3-f391195c2cd401064140c6962884e130.png";